<template>
  <div v-if="loading" class="preview-multi-select">
    <b>{{ $i18n('interface.novo_filtro.fornecedor') }}:</b> <span>{{ $i18n('interface.novo_filtro.selecione') }}</span>
  </div>
  <MultiSelect
    v-else
    :label="$i18n('interface.novo_filtro.fornecedor')"
    :campos="fornecedores"
    :filtro="filtro"
    :filtro_id="filtro.filtro"
    :path="path"
    :buscaRemota="true"
    :buscando="buscando"
    @atualizar="atualizar"
    @buscar="buscarFornecedores"
  />
</template>
<script>
import MultiSelect from '../../components/MultiSelect.vue';

export default {
  components: { MultiSelect },
  props: {
    filtro: { type: Object, required: true },
    path: { type: String, required: true },
  },
  data() {
    return { fornecedores: [], loading: true, buscando: false, termoAtual: '' };
  },
  methods: {
    atualizar(selecionados) {
      this.$aplicaFiltroEmURL(this.filtro.filtro, selecionados, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', { filtro: this.filtro.filtro, valor: selecionados });
    },
    buscarFornecedores(termo = '') {
      const { preselecionados, ...parametrosBusca } = this.filtro?.parametros || {};
      const params = { ...parametrosBusca, tipos: parametrosBusca.tipos || ['fornecedor'] };
      if (termo) params.term = termo;
      this.buscando = true;
      this.termoAtual = termo;
      this.$api.get('/stakeholders/busca_todos', { params }).then(({ data }) => {
        if (this.termoAtual !== termo) return;
        const preselecionados = this.filtro?.parametros?.preselecionados || [];
        const buscados = data.map(s => ({ id: s.id, name: s.label }));
        const idsBuscados = new Set(buscados.map(c => String(c.id)));
        this.fornecedores = [...preselecionados.filter(p => !idsBuscados.has(String(p.id))), ...buscados];
      }).catch(error => {
        if (this.termoAtual !== termo) return;
        console.error('Erro ao buscar fornecedores:', error);
      }).finally(() => {
        if (this.termoAtual === termo) {
          this.buscando = false;
          this.loading = false;
        }
      });
    },
  },
  mounted() {
    this.fornecedores = this.filtro?.parametros?.preselecionados || [];
    this.buscarFornecedores();
  },
};
</script>
